var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatHighlighted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#00397e;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25,5.1C13,5.1,3.3,13.2,3.3,23c0,4.9,2.4,9.3,6.1,12.4l-2.2,9.4l11.6-4.7c2,0.5,3.9,0.7,6.1,0.7 c12,0,21.7-8,21.7-17.9C46.7,13.2,37,5.1,25,5.1z M25,38.9c-1.9,0-3.7-0.2-5.6-0.7c-0.2,0-0.3-0.1-0.5-0.1c-0.3,0-0.5,0-0.7,0.1 L10,41.5l1.3-5.7c0.2-0.7-0.1-1.5-0.7-2c-3.6-3-5.4-6.9-5.4-11C5.2,14.2,14.1,7,24.9,7c10.8,0,19.7,7.2,19.7,15.9 C44.6,31.7,35.8,38.9,25,38.9z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatHighlighted);
export default __webpack_public_path__ + "static/media/chat-highlighted.d74d58b20e6e8c26a66a3360e675cbdc.svg";
export { ForwardRef as ReactComponent };